import { render, staticRenderFns } from "./HorseParentForm.vue?vue&type=template&id=b0d619dc&"
import script from "./HorseParentForm.vue?vue&type=script&lang=js&"
export * from "./HorseParentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports